module.exports = __webpack_public_path__ + "static/img/mingf10.8bc40f2a.png";